module.exports = __webpack_public_path__ + "static/media/leak-pod-info-alert.4f25e5bd.svg";